module.exports = __webpack_public_path__ + "static/img/top_image2.135e8b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top_image2.png
// module id = suWI
// module chunks = 0